import { Component } from '@angular/core';

import {VoiceService} from '../../services/voice/voice.service';
import {WordPlayBtnComponent} from './word-play-btn.component';

@Component({
  selector: 'app-popup-word-play-btn',
  styleUrls: ['./popup-word-play-btn.component.scss'],
  template: `
    <button type="button"
            *ngIf="word && word.wordVoice"
            class="popup-sound-btn {{ on ? 'on' : '' }}"
            (click)="playSound($event)"></button>
  `,
})
export class PopupWordPlayBtnComponent extends WordPlayBtnComponent {

  constructor(
    protected voice: VoiceService,
  ) {
    super(voice);
  }

}
